import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Fund Billing API
 */
class FundBillingApi extends ApiBase {
  async fetchFundBilling(fundId) {
    const request = {
      url: `${this.API_URL}/fundbilling?fundId=${encodeURIComponent(fundId)}`,
      method: 'GET',
      headers: this.getHeaders()
    };
    
    const response = await axios.request(request);
    
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }
      
    return response.data;
  }

  async createOrUpdateFundBilling(payload) {
    const request = {
      url: `${this.API_URL}/fundbilling`,
      method: 'PUT',
      headers: this.getHeaders(),
      data: payload
    };
  
    const response = await axios.request(request);
  
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }
  
    return response.data;
  }

  async fetchFundBillingHistory(fundId) {
    const request = {
      url: `${this.API_URL}/fundbilling/history?fundId=${encodeURIComponent(fundId)}`,
      method: 'GET',
      headers: this.getHeaders()
    };
    
    const response = await axios.request(request);
    
    if (response.status === 504) {
      throw new Error('The request took too long and timed out.');
    }
      
    return response.data;
  }
}

export default new FundBillingApi();
